import React from 'react'; 
import blueIcon from '../hybridImages/BlueBulbIcon.png';
import reportIcon from '../hybridImages/certificate.png';
import bankIcon from '../hybridImages/bank.png';
import certIcon from '../hybridImages/certificate.png';
 
const BlueboxIconTxt = (props) => {
    
    return(
    <div className="row around-xs inputPair elementVisible">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div className='bluebox'>
                <div style={{display:'inline-flex'}}>
                    <img className='upload-left-icon-size' src={blueIcon} alt='blue-bulb' />&nbsp;&nbsp;
                    <span>Submitting these supporting documents will speed up the application</span>
                </div>
              
                <div className='blueboxIconTxtPadding'>
                    <div style={{display:'inline-flex'}}>
                        <img className='upload-left-icon-size' src={certIcon} alt='cert' />&nbsp;
                        <span>Latest 2 Years Financial Report: company's profit & loss and balance sheet</span>
                    </div> 
                </div>
                <div className='blueboxIconTxtPadding'>
                    <div style={{display:'inline-flex'}}>
                        <img className='upload-left-icon-size' src={bankIcon} alt='bank' />&nbsp; 
                        <span>Latest 6 Months Operating Bank Statement: Primary account for business transactions</span>
                    </div>
                </div>
                <div className='blueboxIconTxtPadding'>
                    <div style={{display:'inline-flex'}}>
                        <img className='upload-left-icon-size' src={reportIcon} alt='report' />&nbsp; 
                        <span>Option To Purchase (OTP) - for property loans only</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}

export default BlueboxIconTxt